import { DETAIL_VIEW, SIMPLE_VIEW, TestStepsView } from '@qality/common-model';
import { LocalStorageUtils, Utils } from '@qality/common-utils';

export default {
  getViewTypeOptions(): Array<TestStepsView> {
    return [SIMPLE_VIEW, DETAIL_VIEW];
  },
  fetchView(issueKey: string): TestStepsView {
    const viewStorage = LocalStorageUtils.retrieveUserSettings(
      'view-' + issueKey
    );
    if (Utils.isNilOrEmpty(viewStorage)) {
      LocalStorageUtils.storeUserSettings(SIMPLE_VIEW, 'view-' + issueKey);
      return SIMPLE_VIEW;
    }
    return viewStorage;
  },

  saveView(issueKey: string, viewType: TestStepsView): boolean {
    LocalStorageUtils.storeUserSettings(viewType, 'view-' + issueKey);
    return true;
  },

  fetchExecutionViewType(executionId: number): TestStepsView {
    const viewStorage = LocalStorageUtils.retrieveUserSettings(
      'execution-view-' + executionId
    );
    if (Utils.isNilOrEmpty(viewStorage)) {
      LocalStorageUtils.storeUserSettings(
        DETAIL_VIEW,
        'execution-view-' + executionId
      );
      return DETAIL_VIEW;
    }
    return viewStorage;
  },
  saveExecutionViewType(executionId: number, viewType: TestStepsView): boolean {
    LocalStorageUtils.storeUserSettings(
      viewType,
      'execution-view-' + executionId
    );
    return true;
  },
};
